import { useSelector } from 'react-redux'
import { NavLink, Route, Routes } from 'react-router-dom'

import { Translation } from '@/components/i18n/Translation'
import { getCustomerId, getCustomerIsSubscriptionDealer } from '@/ducks/customerReducer'
import { useIsBechtle } from '@/hooks/user'
import { appRoutes } from '@/util/misc'

import TabAdmin from './admin/TabAdmin'
import TabCostObjects from './cost-objects/TabCostObjects'
import TabFrameAgreement from './frame-agreement/TabFrameAgreement'

import './customer-tabs.scss'

const CustomerTabs = () => {
  const isBechtle = useIsBechtle()
  const customerId = useSelector(getCustomerId)

  const isSubscriptionDealer = Boolean(useSelector(getCustomerIsSubscriptionDealer))
  // @ts-ignore
  const insertCustomerId = path => path.replace(':customer_id', customerId)

  if (isBechtle) return null

  return (
    <div className="customer-tabs">
      <ul className="customer-tabs__nav">
        {isSubscriptionDealer && (
          <li>
            <NavLink
              end
              className={({ isActive }) => (isActive ? 'is-active' : '')}
              to={insertCustomerId(appRoutes.customer)}
            >
              <Translation id="Phones" />
            </NavLink>
          </li>
        )}

        <li>
          <NavLink
            className={({ isActive }) => (isActive ? 'is-active' : '')}
            to={insertCustomerId(appRoutes.customerTabFrameAgreement)}
          >
            <Translation id="Frame Agreement" />
          </NavLink>
        </li>

        {isSubscriptionDealer && (
          <li>
            <NavLink
              className={({ isActive }) => (isActive ? 'is-active' : '')}
              to={insertCustomerId(appRoutes.customerTabAdmin)}
            >
              <Translation id="Admin" />
            </NavLink>
          </li>
        )}
      </ul>

      <Routes>
        <Route path="" element={<TabCostObjects />} />
        <Route path="frame-agreement" element={<TabFrameAgreement />} />
        <Route path="admin" element={<TabAdmin />} />
      </Routes>
    </div>
  )
}

export default CustomerTabs
